import { useSyncExternalStore } from 'react';

export const DATA_BUS_SCOPES = {
  FINANCE_TRENDS: 'finance-trends',
  NET_WORTH_TRENDS: 'net-worth-trends',
};

const listeners = new Set();
const scopedVersions = new Map();

const getScopedKey = (scope, householdId) => `${scope}:${householdId ?? 'none'}`;

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

export const publishScopedDataChange = ({ scope, householdId }) => {
  if (!scope || householdId == null) return;
  const scopedKey = getScopedKey(scope, householdId);
  scopedVersions.set(scopedKey, (scopedVersions.get(scopedKey) || 0) + 1);
  emitChange();
};

export const getScopedDataVersion = ({ scope, householdId }) => {
  if (!scope || householdId == null) return 0;
  return scopedVersions.get(getScopedKey(scope, householdId)) || 0;
};

export const subscribeScopedDataVersion = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useScopedDataVersion = ({ scope, householdId }) => useSyncExternalStore(
  subscribeScopedDataVersion,
  () => getScopedDataVersion({ scope, householdId }),
  () => 0
);

export const resetScopedDataBus = () => {
  scopedVersions.clear();
  emitChange();
};

export const resetScopedDataScope = (scope) => {
  if (!scope) return;
  [...scopedVersions.keys()].forEach((scopedKey) => {
    if (scopedKey.startsWith(`${scope}:`)) {
      scopedVersions.delete(scopedKey);
    }
  });
  emitChange();
};
